import React, { useState } from "react";
import "../styles/ZodiacSign.css";

function ZodiacSignCard({ sign, img, forcast }) {
  const [forcastSize, setForcastSize] = useState("0em");
  const [btn, setBtn] = useState(true);
  const [btnMessage, setBtnMessage] = useState("Display...");

  // Gestion de l'affichage des prévisions astrologiques :

  const handleForcastDisplay = () => {
    if (btn) {
      setBtnMessage("Hide");
      setBtn(false);
      setForcastSize("1em");
    } else {
      setForcastSize("0em");
      setBtnMessage("Display...");
      setBtn(true);
    }
  };

  return (
    <div
      className="col-6 card text-white bg-dark mb-3"
      style={{ width: "15rem" }}
    >
      <img src={img} className="card-img-top" alt="signe astrologique" />
      <div className="card-body text-center">
        <h5 className="card-title ">{sign}</h5>
        <p className="card-text" style={{ fontSize: forcastSize }}>
          {forcast}
        </p>
        <button className="btn btn-primary" onClick={handleForcastDisplay}>
          {btnMessage}
        </button>
      </div>
    </div>
  );
}

export default ZodiacSignCard;
